import React, { useEffect, useState } from 'react'

export const useFetch = (api,query="") => {

    const [data,setData]=useState([]);  

    const url=`https://api.themoviedb.org/3/${api}?api_key=8521a99ccbbd2c279fe86758024d9efa&query=${query}`

    useEffect(()=>{
        async function fetchMovies(){
            const response=await fetch(url);
            const json=await response.json();
            setData(json.results)
        }
        fetchMovies();
    },[url])

  return {data};
}
